import "core-js/modules/es6.function.bind";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import * as React from 'react';
import Platform from "react-native-web/dist/exports/Platform";
import getNode from "./getNode";
export default function createPseudoHook(_ref) {
  var events = _ref.events;
  return function (ref) {
    var _this = this;

    if (Platform.OS !== 'web') {
      return false;
    }

    var _React$useState = React.useState(false),
        _React$useState2 = _slicedToArray(_React$useState, 2),
        isActive = _React$useState2[0],
        setActive = _React$useState2[1];

    React.useEffect(function () {
      var _events = _slicedToArray(events, 2),
          eventIn = _events[0],
          eventOut = _events[1];

      var node = getNode(ref);

      if (!node) {
        return;
      }

      var resolve = function resolve(value) {
        setActive(value);
      };

      var onStart = resolve.bind(_this, true);
      var onEnd = resolve.bind(_this, false);
      node.addEventListener(eventIn, onStart);
      node.addEventListener(eventOut, onEnd);

      if (eventOut === 'mouseup') {
        document.addEventListener(eventOut, onEnd, false);
      }

      return function () {
        document.removeEventListener(eventOut, onEnd, false);
        node.removeEventListener(eventIn, onStart);
        node.removeEventListener(eventOut, onEnd);
      };
    }, [ref && ref.current]);
    return isActive;
  };
}